export default "__VITE_ASSET__B0LOmo0Z__"